import { logger } from '@libs/core';

export type GeolocationResponse = {
    coords: {
        accuracy: number;
        latitude: number;
        longitude: number;
    };
};

export type UserLocation = {
    latitude?: number;
    longitude?: number;
    isGeolocationEnabled?: boolean;
};

function getCurrentPositionPromise(): Geolocation | unknown {
    return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(resolve, reject);
        } else {
            reject(new Error('Geolocation is not supported by this browser.'));
        }
    });
}

/*
    Safari will keep asking the user if they want to share their location if they refresh the page.
    But it does not show on page load.
*/
export const getUserLocation = async (): Promise<UserLocation> => {
    let location: UserLocation = { isGeolocationEnabled: false };
    if (navigator.permissions) {
        try {
            const result = await navigator.permissions.query({
                name: 'geolocation',
            });
            if (result.state === 'prompt' || result.state === 'granted') {
                const promise: GeolocationResponse = (await getCurrentPositionPromise()) as GeolocationResponse;
                location = {
                    latitude: promise?.coords?.latitude,
                    longitude: promise?.coords?.longitude,
                    isGeolocationEnabled: true,
                };
            }
        } catch (e) {
            logger.info('User denied location services', e);
        }
    }
    logger.error('Permissions API is not supported in this browser.');
    return location;
};
